import { ClientAccountEntity } from '@galabid/gb-dashboard/client-account/data-access'
import {
  CountdownWidgetModel,
  HonourRollWidgetModel,
  ImageWidgetModel,
  ItemTableWidgetModel,
  NotificationWidgetModel,
  QrCodeWidgetModel,
  RaffleDrawWidgetModel,
  RaffleWinnersWidgetModel,
  SmartTextWidgetModel,
  TeamScoringWidgetModel,
  PowerPledgeWidgetModel,
  TextWidgetModel,
  ThermometerWidgetModel,
  TotalRaisedWidgetModel,
} from 'libs/gb-dashboard/presenter/data-access-presenter-widgets/src/lib/+state/presenter-widgets.models'
import { ImagesEntity } from 'libs/shared/models/images/image.models'

export interface ProjectorTemplateImageEntity {
  uuid: string
  image_url?: string
  preload_image?: string
  thumbnail_image?: string
  small_image?: string
  medium_image?: string
}

export interface ProjectorTemplatesEntity {
  uuid: string
  name: string
  description: string
  order: number
  is_public_all_client_accounts: boolean
  distributor: string | null
  client_accounts: Partial<ClientAccountEntity>[]
  background_image?: ProjectorTemplateImageEntity | null
  config: string
  created_by: string | null
  updated_by: string | null
  schema_version?: number | null
}

export interface ParsedPresenterConfig {
  projector: {
    background_color: string
    background_image: ImagesEntity | undefined | null // TODO GB-11987
    background_image_cover: boolean
    custom_css: string
  }
  imageWidgets: ImageWidgetModel[]
  itemTableWidgets: ItemTableWidgetModel[]
  notificationWidgets: NotificationWidgetModel[]
  textWidgets: TextWidgetModel[]
  totalRaisedWidgets: TotalRaisedWidgetModel[]
  raffleDrawWidgets: RaffleDrawWidgetModel[]
  raffleWinnersWidgets: RaffleWinnersWidgetModel[]
  thermometerWidgets: ThermometerWidgetModel[]
  countdownWidgets: CountdownWidgetModel[]
  smartTextWidgets: SmartTextWidgetModel[]
  teamScoringWidgets: TeamScoringWidgetModel[]
  honourRollWidgets: HonourRollWidgetModel[]
  qrCodeWidgets: QrCodeWidgetModel[]
}

export interface ProjectorTemplateRawConfig {
  Projector: {
    id: number
    uuid: string
    is_active: boolean
    auction_id: number | null
    name: string
    background_image: string
    background_color: string
    custom_css: string
    last_notification_time: string | null
    background_image_cover: boolean
    font_family: string | null
    color: string | null
  }
  TextProjectorWidget: TextWidgetModel[]
  ImageProjectorWidget: ImageWidgetModel[]
  ItemTableProjectorWidget: ItemTableWidgetModel[]
  TotalRaisedProjectorWidget: TotalRaisedWidgetModel[]
  NotificationProjectorWidget: NotificationWidgetModel[]
  RaffleDrawProjectorWidget: RaffleDrawWidgetModel[]
  RaffleWinnersProjectorWidget: RaffleWinnersWidgetModel[]
  ThermometerProjectorWidget: ThermometerWidgetModel[]
  CountDownProjectorWidget: CountdownWidgetModel[]
  TeamScoringProjectorWidget: TeamScoringWidgetModel[]
  PowerPledgeProjectorWidget: PowerPledgeWidgetModel[]
  SmartTextProjectorWidget: SmartTextWidgetModel[]
  HonourRollProjectorWidget: HonourRollWidgetModel[]
  QrCodeProjectorWidget: QrCodeWidgetModel[]
}

export const TEMPLATES_LOADER = {
  saveTemplate: {
    id: 'saveTemplate',
  },
  saveProjectorAsTemplate: {
    id: 'saveProjectorAsTemplate',
  },
}
